import React from 'react'
import './Login.css'
import AddPhoto from "./img/addi.png";
import logo_user from '../img/logo-banner.png';
import { createUserWithEmailAndPassword, updateProfile } from "firebase/auth";
import { auth } from './firebase';
import { useState } from 'react';
import { db, storage } from './firebase';
import { getStorage, ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { doc, setDoc } from "firebase/firestore";
import {
    createBrowserRouter,
    RouterProvider,
    Route,
    Link,
    Navigate
} from "react-router-dom";
import { useNavigate } from "react-router-dom";

const Register = () => {
    const [err, setErr] = useState(false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();


    //funcion para obtener datos de formulario y enviarlos al backend
    const handleSubmit = async (e) => {
        e.preventDefault();
        const displayName = e.target[0].value;
        const email = e.target[1].value;
        const password = e.target[2].value;
        const file = e.target[3].files[0];
        //función para crear usuario con email y password en firebase auth 
        try {
            //Create user
            const res = await createUserWithEmailAndPassword(auth, email, password);

            //Create a unique image name
            const date = new Date().getTime();
            const storageRef = ref(storage, `${displayName + date}`);

            await uploadBytesResumable(storageRef, file).then(() => {
                getDownloadURL(storageRef).then(async (downloadURL) => {
                    try {
                        //Update profile
                        await updateProfile(res.user, {
                            displayName,
                            photoURL: downloadURL,
                        });
                        //create user on firestore
                        await setDoc(doc(db, "users", res.user.uid), {
                            uid: res.user.uid,
                            displayName,
                            email,
                            photoURL: downloadURL,
                        });

                        //create empty user chats on firestore
                        await setDoc(doc(db, "userChats", res.user.uid), {});
                        navigate("/");
                    } catch (err) {
                        console.log(err);
                        setErr(true);
                        setLoading(false);
                    }
                });
            });
        } catch (err) {
            setErr(true);
            setLoading(false);
        }
    };



    return (
        <div className='principal'>
            <div className='container-login'>
                <form onSubmit={handleSubmit} className='formulario'>
                    <div className='titulo'>
                        <h1>Registro</h1>
                    </div>
                    <input required={true} className='loginiput' type="text" placeholder='Nombre' />
                    <input required={true} className='loginiput' type="text" placeholder='Username' />
                    <input required={true} className='loginiput' type="password" placeholder='Password' />
                    <input style={{ display: "none" }} type="file" id='file' />
                    <label htmlFor="file">
                        <img className='addimg' src={AddPhoto} alt="" />
                        <span>Agregar foto</span>
                    </label>
                    <button disabled={loading} className='btnlogin' type="submit" >Registrar</button>
                    {loading && "Uploading and compressing the image please wait..."}
                    <p className='log'>Ya tienes cuenta? <Link to="/Login">Login</Link></p>

                    <img className='logobanner' src={logo_user} alt="" />
                    {err &&
                        <div className="alert alert-danger" role="alert">
                            <strong>Error:</strong> El usuario ya existe, prueba con otro nombre
                        </div>}




                </form>
            </div>
        </div >
    )
}

export default Register